// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectedOption {
  color: black;
  transform: scale(1.05);
  margin: 0px 10px;
  cursor: pointer;
  font-weight: 500;
}

.notSelected {
  margin: 0px 10px;
  color: grey;
  cursor: pointer;
}

.selectedQuiz {
  background-color: #003151;
  color:white;
  border: none;
  align-items: center;
  justify-content: center;
  margin: 5%;
  height: 100%;
  transform: scale(1.02);
  display: inline-block;
}

.selectedQuiz::after{
    content: '';
    position: absolute;
    left: 100%;
    top: 28%;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
	border-left: 10px solid #003151;
	border-bottom: 10px solid transparent;
    clear: both;
    display: inline-block;
  }

.notSelectedQuiz {
  /* border: none; */
  border-radius: 8%;
  align-items: center;
  justify-content: center;
  margin: 5% 8%;
  height: 20%;
  background-color: #A25035;
  color:black;
  display: inline-block;
}

.nav-outerdiv{
  display: inline-block;
  width: 30%;
  height: 100%;
  background-color: #F5F5F5;
  border-radius: 20px 0px 0px 20px ;
}
.learnerNav-innerdiv{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: max-content;
  margin: auto;
  height:5%;
 


}
.title, .title2{
  font-family: Merriweather Sans;
  font-weight: bold;
  margin: 15px 15px 3px;
  font-size: 1.2rem;
}
.title2{
  display: inline-block;
  width: 60%;
}
.nav-height{
  height: 85%;
}

`, "",{"version":3,"sources":["webpack://./src/components/modules/learners/LearnersNav.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,kCAAkC;CACrC,+BAA+B;CAC/B,qCAAqC;IAClC,WAAW;IACX,qBAAqB;EACvB;;AAEF;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,SAAS;;;;AAIX;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,WAAW;AACb","sourcesContent":[".selectedOption {\n  color: black;\n  transform: scale(1.05);\n  margin: 0px 10px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.notSelected {\n  margin: 0px 10px;\n  color: grey;\n  cursor: pointer;\n}\n\n.selectedQuiz {\n  background-color: #003151;\n  color:white;\n  border: none;\n  align-items: center;\n  justify-content: center;\n  margin: 5%;\n  height: 100%;\n  transform: scale(1.02);\n  display: inline-block;\n}\n\n.selectedQuiz::after{\n    content: '';\n    position: absolute;\n    left: 100%;\n    top: 28%;\n    width: 0;\n    height: 0;\n    border-top: 10px solid transparent;\n\tborder-left: 10px solid #003151;\n\tborder-bottom: 10px solid transparent;\n    clear: both;\n    display: inline-block;\n  }\n\n.notSelectedQuiz {\n  /* border: none; */\n  border-radius: 8%;\n  align-items: center;\n  justify-content: center;\n  margin: 5% 8%;\n  height: 20%;\n  background-color: #A25035;\n  color:black;\n  display: inline-block;\n}\n\n.nav-outerdiv{\n  display: inline-block;\n  width: 30%;\n  height: 100%;\n  background-color: #F5F5F5;\n  border-radius: 20px 0px 0px 20px ;\n}\n.learnerNav-innerdiv{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  width: max-content;\n  margin: auto;\n  height:5%;\n \n\n\n}\n.title, .title2{\n  font-family: Merriweather Sans;\n  font-weight: bold;\n  margin: 15px 15px 3px;\n  font-size: 1.2rem;\n}\n.title2{\n  display: inline-block;\n  width: 60%;\n}\n.nav-height{\n  height: 85%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
